import styled from 'styled-components';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FontWeight, PRESSABLE } from '../../../../common/styles/constants';
import { propSwitch } from '../../../../common/util/propSwitch';

export const DisclosureButton = styled.button`
  background: none;
  border: none;
  ${PRESSABLE};
  color: ${ThemeColours.primary};
  display: inline;
  font-size: inherit;
  font-weight: ${FontWeight.SEMI_BOLD};
  white-space: nowrap;
`;

export const Contents = styled.div<{ shown: boolean }>`
  display: ${propSwitch('shown', 'contents', 'none')};
`;
